module.exports = __webpack_public_path__ + "media/content-creator/tech-1-65fe851d.png";